import React from 'react';
import PropTypes from 'prop-types';

const Avatar = props => (
  <section className={'avatar-image' + (props.className ? ' ' + props.className : '')}>
    <img src={props.src} width={props.width} />
    {props.name && <div className="avatar-name">{props.name.toUpperCase()}</div>}
  </section>
);

export default Avatar;



// WEBPACK FOOTER //
// ./source/client/components/common/avatar.jsx